export const PRODUCT_ID = {
    DRAWER_COMPONENT: 355,
};
